import React, { useEffect } from "react";

// Routes
import { useUserData } from "./context/UserDataContext.js";

//................. Admin
import AdminRoutes from "./components/admin-panels/shares/AdminRoutes.js";
//..................... Customer
import CustomerRoutes from "./components/customer-panels/shares/CustomerRoutes.js";
import EmployeeRoutes from "./components/employee-panels/shares/EmployeeRoutes.js";
//..................... Producers
import ProducerRoutes from "./components/producer-panels/shares/ProducerRoutes.js";

import { SettingProvider } from "./context/SettingContext.js";

const Authenticated = () => {
  const { userData } = useUserData();

  return (
    <>
      <SettingProvider>
        {userData.job == "Admin" && <AdminRoutes />}
        {userData.job == "Customer" && <CustomerRoutes />}
        {userData.job == "Employee" && <EmployeeRoutes />}
        {userData.job == "Provider" && <ProducerRoutes />}

        {/* 1 */}
        {/* <Route path="/redirect" element={<Navigate to="/setting-ring"/>}/> */}
        {/* 2 */}
        {/* <Route path="/setting/*" element={<Ring />} />
          in the Ring Component use the nested route like below:
          <Routers>
            <Route path="/nested" element={<Nested />} />
          </Routers> */}
      </SettingProvider>
    </>
  );
};
export default Authenticated;
